import React from 'react'

export const useScrollToTop = () => {
  const [scrollPosition, setScrollPosition] = React.useState({
    scrollTop: 0,
  })
  const ref = React.useRef(null)

  const handleScrollToTop = React.useCallback(() => {
    if (ref.current) {
      ref.current.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }, [])

  const handleScroll = React.useCallback(() => {
    if (ref.current) {
      setScrollPosition({ scrollTop: ref.current.scrollTop })
    }
  }, [])

  return {
    state: { ref, scrollPosition },
    handlers: { handleScroll, handleScrollToTop },
  }
}
